import { jsx as _jsx } from "react/jsx-runtime";
import { useAetherContext } from '#pplx/frontend/aether/components/AetherProvider/useAetherContext.js';
import { MenuItemBase } from '#pplx/frontend/aether/components/internal/menu/MenuItemBase.js';
import { Switch } from '#pplx/frontend/aether/components/Switch/index.js';
import { DropdownMenuPrimitive } from '#pplx/frontend/aether/primitives/DropdownMenuPrimitive/index.js';
import { useCallback, useMemo, useRef } from 'react';
export function MenuSwitchItem({ children, checked, onCheckedChange, textValue, disabled, leadingAccessory, subtitle, badge, badgeVariant, ...rest }) {
    const { isMobileStyle } = useAetherContext();
    const menuItemRef = useRef(null);
    const handleSelect = useCallback((event) => {
        // Prevent the default selection behavior to avoid closing the menu
        event.preventDefault();
    }, []);
    const handleClick = useCallback(() => {
        if (disabled) {
            return;
        }
        onCheckedChange(!checked);
    }, [checked, disabled, onCheckedChange]);
    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            // Prevent default to avoid scrolling on Space key
            e.preventDefault();
            handleClick();
        }
    }, [handleClick]);
    const handleSwitchClick = useCallback((event) => {
        // The switch handles its own state change; don't also activate the parent menu item.
        event.stopPropagation();
        menuItemRef.current?.focus();
    }, []);
    const trailingAccessory = useMemo(() => {
        // Switch exposes semantic state changes rather than a raw click handler. This presentation
        // wrapper is the event boundary that prevents its click from activating the row as well.
        return (_jsx("span", { role: "presentation", onClick: handleSwitchClick, children: _jsx(Switch, { checked: checked, onCheckedChange: onCheckedChange, disabled: disabled, "aria-label": "", size: "small", 
                // The containing menu item owns keyboard interaction and Radix roving focus.
                tabIndex: -1 }) }));
    }, [checked, disabled, handleSwitchClick, onCheckedChange]);
    // Mobile renders within a dialog (i.e: bottom sheet) so
    // we don't need to wrap within an accessible menu item
    // and just render as standard switch.
    if (isMobileStyle) {
        return (_jsx(MenuItemBase, { ref: menuItemRef, leadingAccessory: leadingAccessory, trailingAccessory: trailingAccessory, subtitle: subtitle, badge: badge, badgeVariant: badgeVariant, role: "switch", "aria-checked": checked, tabIndex: disabled ? -1 : 0, onClick: handleClick, onKeyDown: handleKeyDown, "aria-disabled": disabled, ...rest, children: children }));
    }
    return (_jsx(DropdownMenuPrimitive.CheckboxItem, { disabled: disabled, checked: checked, onCheckedChange: onCheckedChange, onSelect: handleSelect, textValue: textValue, ...rest, children: _jsx(MenuItemBase, { ref: menuItemRef, leadingAccessory: leadingAccessory, trailingAccessory: trailingAccessory, subtitle: subtitle, badge: badge, badgeVariant: badgeVariant, children: children }) }));
}
//# sourceMappingURL=MenuSwitchItem.js.map